// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions__e5e {
  margin-top: calc(var(--ring-unit) * 1.5);

  display: flex;
  gap: var(--ring-unit);
}

.licenseData__f01 {
  margin-top: var(--ring-unit);
}

.licenseData__f01 + .addMore__b12 {
  margin-top: calc(var(--ring-unit) / 2);
}

.addMore__b12 {
  margin-top: calc(var(--ring-unit) * 1.5);
}

.deniedRequests__a55 {
  margin-top: calc(var(--ring-unit) * 1.5);

  display: flex;
  align-items: center;
}

.deniedRequestsIcon__c6d {
  color: var(--ring-error-color);
}

.deniedRequestsMsg__c2f {
  margin-left: calc(var(--ring-unit) / 2);
  color: var(--ring-error-color);
}

.deniedRequestsLink__cca {
  margin-left: calc(var(--ring-unit) * 1.5);
}

.prepaid__a66 {
  margin-right: calc(var(--ring-unit) * 1.5);
}
`, "",{"version":3,"sources":["webpack://./src/modules/license-vault/license-vault-constituent/license-vault-state-block/license-vault-enabled/license-vault-enabled.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;;EAExC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;;EAExC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".actions {\n  margin-top: calc(var(--ring-unit) * 1.5);\n\n  display: flex;\n  gap: var(--ring-unit);\n}\n\n.licenseData {\n  margin-top: var(--ring-unit);\n}\n\n.licenseData + .addMore {\n  margin-top: calc(var(--ring-unit) / 2);\n}\n\n.addMore {\n  margin-top: calc(var(--ring-unit) * 1.5);\n}\n\n.deniedRequests {\n  margin-top: calc(var(--ring-unit) * 1.5);\n\n  display: flex;\n  align-items: center;\n}\n\n.deniedRequestsIcon {\n  color: var(--ring-error-color);\n}\n\n.deniedRequestsMsg {\n  margin-left: calc(var(--ring-unit) / 2);\n  color: var(--ring-error-color);\n}\n\n.deniedRequestsLink {\n  margin-left: calc(var(--ring-unit) * 1.5);\n}\n\n.prepaid {\n  margin-right: calc(var(--ring-unit) * 1.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `actions__e5e`,
	"licenseData": `licenseData__f01`,
	"addMore": `addMore__b12`,
	"deniedRequests": `deniedRequests__a55`,
	"deniedRequestsIcon": `deniedRequestsIcon__c6d`,
	"deniedRequestsMsg": `deniedRequestsMsg__c2f`,
	"deniedRequestsLink": `deniedRequestsLink__cca`,
	"prepaid": `prepaid__a66`
};
export default ___CSS_LOADER_EXPORT___;
